export default __webpack_public_path__ + "static/media/photo--lg--64.c94aca25.jpg";